import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "itemRight"];
import { Flex } from 'foundations-components/components/Flex';
import { H3 } from 'foundations-components/transitional/components/H3';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function InnerSectionHeading(_ref) {
  let {
      children,
      itemRight
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterTokenProps(rest);
  const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
  const Container = styled.div.withConfig({
    displayName: "InnerSectionHeading__Container",
    componentId: "sc-1i3pgn9-0"
  })(({
    $spaceCssStyles
  }) => {
    return Object.assign({}, $spaceCssStyles);
  });
  if (itemRight) {
    return /*#__PURE__*/_jsx(Container, {
      $spaceCssStyles: spaceCssStyles,
      children: /*#__PURE__*/_jsxs(Flex, {
        marginBlockEnd: "100",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        children: [/*#__PURE__*/_jsx(H3, {
          paddingBlockEnd: "0",
          children: children
        }), itemRight]
      })
    });
  }
  return /*#__PURE__*/_jsx(H3, Object.assign({}, rest, {
    children: children
  }));
}